import { Button, Grid, MenuItem, TextField, Checkbox, FormControlLabel } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { getEvents } from '../../../store/constructs/events/selectors';
import { useSelector } from 'react-redux'
import { useDispatch } from "react-redux";
import shortUuid from 'short-uuid'
import CreateMessage from '../messages/CreateMessage'
import { getExternalFunctions } from '../../../store/constructs/clusterlets/selectors'
import CreateCancel from "../../atoms/buttons/CreateCancel";
import { Controller, useForm } from "react-hook-form";
import { basic, validationMessages, requiredOnlyMessage, requiredOnly, patternOnly, patternOnlyMessage } from '../../../config/validations';
import { getConstructType, getConstructLabel, nodeKeysLabel, aiNodes } from '../../../config/common';
import { getTemplatecluserletMessages } from '../../../store/constructs/templated_clusterlet/selectors'
import { getBlueprintDetails } from '../../../store/global/selectors'
import { rrdefAutomation } from '../../../services/entities/routing_rules';
import { makeStyles } from '@material-ui/core/styles';
import { invokePostService, invokeGetService, setReRender, toggleRightDrawer, handleSnackBar } from "../../../store/global/actions";
import { useHistory } from "react-router-dom";
import { getMessageForDropDown } from '../../../services/entities/common'
import {  useParams } from 'react-router-dom';
import { findTransactionAssociatedConstructs, findTriggerEvent, validateNonAsciiChars, convertObjectToArrays, findMessageAndFields, filterUniqueMessages, filterSchemaMessages } from "../../../utils/commonUtils";
import DatabaseSchemaValidationAlert from "../alerts/DatabaseSchemaValidationAlert";
import { isCoordinateInsideRectangle } from "../../../utils/drawingUtils";

const useStyles = makeStyles({
    button: {
        height: 53,
        marginLeft: 10
    }
})

export default function CreateEvent({ element, onCancel, onCompletion }) {

    const classes = useStyles();
    const history = useHistory();
    const params = useParams();


    let [, , slug, id, tag, transaction] = history.location.pathname.split("/");

    const [event, setEvent] = useState({ name: '', condition: '', instance: '', message: '', attributes: { onsend: false, onrecv: false } })
    const [showEventForm, setShowEventForm] = useState(true)
    const dispatch = useDispatch()
    const [action, setAction] = useState({});
    const [eventType, setEventType] = useState({});
    const [conditionMandatory, setConditionMandatory] = useState(false);
    const [message, setMessage] = useState({ _id: "" });
    const [clusterlets, setClusterlets] = useState([]);
    // let messageList = useSelector(getMessageList);
    const [messageList, setMessageList] = useState([]);
    const delegateArray = useSelector(getExternalFunctions);
    // const currentTransaction = useSelector(getSelectedTransactions);
    const [currentTransaction, setCurrentTransaction] = useState({});
    const [allEvents, setAllEvents] = useState([]);
    const eventList = useSelector(getEvents);
    // const allTransactionsList = useSelector(getAllTransactions);
    const [allTransactionsList, setAllTransactionList] = useState([]);
    const [delegateMessages, setDelegateMessages] = useState([]);

    // const clusterlets = useSelector(getClusterlets);
    // const clusterlets = getBlueprintData('clusterlets');
    const templateMessages = useSelector(getTemplatecluserletMessages)
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, setError } = useForm();
    const blueprintDetails = useSelector(getBlueprintDetails);

    let srcNode = clusterlets.find(clusterlet => clusterlet?._id === element?.item?.startClusterlet?.id)
    let dstNode = clusterlets.find(clusterlet => clusterlet?._id === element?.item?.endClusterlet?.id)
    let srcNodeType = getConstructType(srcNode?.type)
    let dstNodeType = getConstructType(dstNode?.type)
    let srcNodeLabel = getConstructLabel(srcNode?.type);
    let dstNodeLabel = getConstructLabel(dstNode?.type);
    let onsendCb = false;
    let onrecvCb = false;
    const messages = { ...validationMessages, ...requiredOnlyMessage, ...patternOnlyMessage, validate: 'The event name is already used.' };
    onsendCb = (delegateArray.map(delegate => delegate.id).includes(element?.item?.startClusterlet?.id))
    const allMessages = [...messageList, ...templateMessages]
    const [conditionTest, setConditiontest] = useState('123');
    let protocol = srcNode?.type == 1 ? srcNode?.attributes?.type : dstNode?.type == 1 ? dstNode?.attributes?.type : undefined;

    const [sourceName, setSourceName] = useState('')
    const [destinationName, setDestinationName] = useState('')
    const [isResponseEvent, setResponseEvent] = useState(false)
    const [isCreating, setIsCreating] = useState(false)
    const [createdMessage, setCreatedMessage] = useState(null);
    const [messageLists , setAllMessageList] = useState([])
    const [fieldsLists , setAllFieldList] = useState([])
    const [mesageFromDb , setMessageFromDb] = useState([])


    useEffect(() => {
        dispatch(invokeGetService('getBlueprintConstructs', {}))
            .then((response) => {
                if (response.status) {
                    // setValue('src', 'src is updated')
                    // setValue('dest', 'dest is updated')
                    setCurrentTransaction(response.data.transactions.find(tr => tr._id == transaction))
                    setAllTransactionList(response.data.transactions)
                    setClusterlets(response.data.clusterlets);
                    setAllEvents(response.data?.events);
                    setMessageList(getMessageForDropDown(response.data.messages))
                    setValue('src', response.data.clusterlets.find(clusterlet => clusterlet._id === element?.item?.startClusterlet?.id)?.name);
                    setValue('dest', response.data.clusterlets.find(clusterlet => clusterlet._id === element?.item?.endClusterlet?.id)?.name);
                    //setValue( {'src': response.data.clusterlets.find(clusterlet => clusterlet._id === element?.startClusterlet?.id).name});
                    // clusterlets.find(clusterlet => clusterlet._id === element?.startClusterlet?.id)?.name
                    setMessageFromDb(response.data.messages)
                }

            })

    }, [])

    useEffect(() => {
        if (message !== undefined) setValue("selectedMessage", message._id);
    }, [message])


    useEffect(() => {
        if (protocol !== undefined) {
            dispatch(invokeGetService('getDbSchema', [protocol]))
                .then((response) => {
                    if (response.status) {
                        if(response?.data != undefined && response?.data?.schema != undefined){
                            let formattedSchema = convertObjectToArrays(response?.data?.schema)
                            setAllMessageList(formattedSchema.messages)
                            setAllFieldList(formattedSchema.fields)
                        }
                    }
                })
        }
    }, [protocol])


    useEffect(() => {
        const parentTransId = findEventParentTransaction(element?.item?.drawnChildTransactions, {x: element?.item.position.x, y: element?.item.position.y});
        const parentTrans = allTransactionsList.find(item => item.id == parentTransId?.id)
        if (parentTrans?.type === 9 && parentTrans?.oneof) setConditionMandatory(true)
    }, [element, allTransactionsList])

    const getClusterletName = (id) => {
        const clusterlet = clusterlets.find(clusterlet => clusterlet._id === id);
        return clusterlet?.name;
    }

    const saveTrigger = (message) => {
        setShowEventForm(true)
        setEvent({ ...event, message: message._id })
    }

    const hideMessageForm = () => {
        setShowEventForm(true)
    }

    const onChange = async (field, value) => {
        setEvent({ ...event, [field]: value })
    }

    // Function for find the parent transaction of an event 
    const findEventParentTransaction = (childTransactions, eventDetails) => {
        try{
            // Don't need to check further if there are no child transactions
            if(!childTransactions) return false;
            
            const {x: eventX, y: eventY} = eventDetails;

            /* 
            * Sort child Transaction in ascending order based on the height of the transaction
            * So, we can find the most inner transaction first
            */
            childTransactions.sort((a,b) => a.height - b.height);

            const parentTransaction = childTransactions?.find(txn => {
                return isCoordinateInsideRectangle({x: eventX, y: eventY}, {x: txn.x, y: txn.y, w: txn.width, h: txn.height})
            })
            return parentTransaction;
        }catch(error){
            console.error("Error on finding event's parent transaction:\n", error)
        }
    }

    const onActionCompletion = (newMessage) => {
        setMessageList([...messageList, { label: newMessage.name, value: newMessage._id }])
        setAction({});
        setMessage(newMessage);

        setCreatedMessage(newMessage);
    }

    const onActionClose = () => {
        setAction({})
    }

    const onEventSave = async (data) => {

        let gotoEventType = false;

        setIsCreating(true);
        let message = formatMessage(data);
        let newEvent = formatEvent({ ...data, message });

        if (createdMessage !== null && createdMessage._id === newEvent.message) gotoEventType = true;

        /**automate rrdef */
        let rrdef = null
        if (srcNode.type === 1 || dstNode.type === 1) rrdef = rrdefAutomation({ event: newEvent, srcNode, dstNode, applicationName: params.slug })

        /** Identify parent transaction - set children, undoredo */
        let parentTransaction = findEventParentTransaction(element?.item?.drawnChildTransactions, {x: element?.item.position.x, y: element?.item.position.y});
        let parent = parentTransaction == undefined ? currentTransaction : parentTransaction;
        let parentTransId = parentTransaction == undefined ? transaction : parentTransaction?.id;

        let messageExists = messageList.find(msg => msg.value == newEvent.message)
        let selectedMessagAndFields = findMessageAndFields(messageLists, fieldsLists, newEvent.message)

        dispatch(invokePostService('createEvent', { event: newEvent, transactionId: parentTransId, order: element.item?.order, messageData: (messageExists == undefined && selectedMessagAndFields != undefined && selectedMessagAndFields?.message != undefined)?  selectedMessagAndFields : null}, []))
            .then((savedData) => {
                setIsCreating(false);
                if (savedData.status) {
                    onCompletion(savedData?.data, 'add', gotoEventType, protocol);
                    dispatch(setReRender())
                } else {
                    if ( savedData?.code === "600") {
                        savedData?.errors?.forEach(error => {
                            setError(error.name, {message: error.message});
                        });
                    } else if (savedData?.code == 254) {
                        dispatch(toggleRightDrawer());
                    } else if (savedData?.message) {
                        dispatch(handleSnackBar({ open: true, message: savedData.message, severity: "error" }));
                    }
                    
                }

            })
            .catch(error => console.error(error));


    }

    /** Format initial message */
    const formatMessage = (event) => {
        return {
            id: shortUuid.generate(),
            name: event.name,
            type: 17
        }
    }

    /** Format the event */
    const formatEvent = (event) => {

        let onsend = false;
        let onrecv = false;
        const { endClusterlet, startClusterlet } = element.item;

        let newEvent = {
            // id: shortUuid.generate(),
            name: event.name,
            desc: event.description,
            message: event.selectedMessage,
            isError: event?.error_resp_event ? true : false,
            attributes: { onsend, onrecv },
            src: startClusterlet.id,
            dst: endClusterlet.id,
            type: 8,
            validation: (!event.validate || event.validate === "") ? 'none' : event.validate,
            timeout: event.timeout,
            key: event.key,
            context: event.context
        }

        if (event.condition != '' && event.condition !== undefined)
            newEvent.condition = event.condition

        if (event.instance != '' && event.instance !== undefined)
            newEvent.instance = event.instance



        const normalMessage = messageList.filter(msg => msg.value === event.selectedMessage);
        if (normalMessage.length == 0) {
            newEvent.messageFromTemplate = true
        }
        return newEvent
    }

    useEffect(() => {
        const {clusterlets: selectedClusterlets, events, transaction: selectedTransaction} = findTransactionAssociatedConstructs({transactionId: transaction, transactions: allTransactionsList, events: allEvents, clusterlets})
        const triggeringEvents = findTriggerEvent({clusterlets: selectedClusterlets, events, transaction: selectedTransaction})
        const { endClusterlet, startClusterlet } = element.item;
        
        if(endClusterlet?.id === triggeringEvents?.src){
            setResponseEvent(true)
        }else{
            setResponseEvent(false)
        }
        console.log({triggeringEvents, endClusterlet, startClusterlet},'This is triggering event');
    },[allEvents, transaction, clusterlets, element])

 

    return (

        <>
            <Grid container direction={"row"} spacing={0}>

                {/* Name */}
                <Grid item xs={12} style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                    <Grid item style={{flex: 2}}>
                        <TextField
                            autoFocus={true}
                            type={"text"}
                            name={"name"}
                            fullWidth
                            required
                            size="small"
                            label={"Event Name"}
                            variant="outlined"
                            // inputRef={register({ ...basic, validate: duplicateEventName({ allEvents: eventList, allTransactionsList, selectedTransaction: currentTransaction, clusterlets, selectedSrc: srcNode.id, element }) })}
                            inputRef={register({ ...basic })}
                            error={errors?.name ? true : false}
                            helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                        />
                    </Grid>
                    {
                        isResponseEvent &&
                        <Grid item>
                            <Controller
                                name="error_resp_event"
                                control={control}
                                render={({ field, onChange }) => (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        {...field}
                                        onChange={e => {
                                          onChange(e.target.checked)
                                        }}
                                        name="error_resp_event"
                                        id="error_resp_event"
                                        color="primary"
                                      />
                                    }
                                    label="Mark as error response"
                                  />
                                )}
                            />
                        </Grid>
                    }
                </Grid>

                {action.action !== 'create_message' && <Grid item xs={9}>
                    <Controller
                        name="selectedMessage"
                        control={control}
                        defaultValue={message._id}
                        rules={{ ...requiredOnly, required: true }}
                        render={({ field, value, onChange }) =>
                            <TextField
                                name="selectedMessage"
                                {...field}
                                label={"Event Type"}
                                disabled={action.action === 'create_message' ? true : false}
                                fullWidth
                                required
                                value={value}
                                select
                                //ref={register({ ...requiredOnly })}
                                variant="outlined"
                                onChange={e => { onChange(e) }}
                                error={errors?.selectedMessage ? true : false}
                                helperText={messages[errors?.selectedMessage?.type] || ''}
                            >
                                <MenuItem key={1} value={""}>Select event type</MenuItem>
                                {[...allMessages, ...filterUniqueMessages({existingMsgs:allMessages,schemaMessages:messageLists || [] })].map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        }
                    />
                </Grid>}

                {action.action !== 'create_message' && <Grid item xs={3} style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button disabled={action.action === 'create_message' ? true : false} onClick={e => setAction({ action: "create_message" })} variant="contained" color="primary" className={classes.button}>
                        Or Create New
                    </Button>
                </Grid>}

                {action.action === 'create_message' && <Grid item xs={12}>
                    <CreateMessage element={element} onClose={onActionClose} onActionCompletion={onActionCompletion} />
                </Grid>}

                <Grid item xs={12}>
                    <TextField
                        type={"text"}
                        name={"description"}
                        fullWidth
                        multiline={true}
                        rows={2}
                        label={"Description"}
                        variant="outlined"
                        inputRef={register({ required: false, validate: validateNonAsciiChars})}
                        error={errors?.description}
                        helperText={errors?.description ? errors?.description?.message : ''}
                    />

                </Grid>


                {/* {srcNodeType !== 'external_function' && <Fragment> */}
                {/* Condition */}
                { /* srcNodeType !== 'external_function' &&  */
                <Grid item xs={12}>
                    <TextField
                        name="condition"
                        type={"text"}
                        fullWidth
                        InputLabelProps={{shrink: true}}
                        // required={conditionMandatory}
                        label={"Condition"}
                        variant="outlined"
                        inputRef={register({ /* required: conditionMandatory, */ })}
                        error={errors?.condition ? true : false}
                        helperText={Boolean(errors.condition) ? <div style={{ color: "red" }}> Condition cannot be empty </div> : ""}
                    // defaultValue={conditionTest}
                    />
                </Grid>}

                <Grid item xs={6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        type={"text"}
                        name={"src"}
                        fullWidth
                        required
                        label={"Source"}
                        variant="outlined"
                        disabled={true}
                        inputRef={register()}
                        // defaultValue={getClusterletName(element?.startClusterlet?.id)}
                        defaultValue={''}
                        helperText={srcNode?.attributes?.type !== undefined && aiNodes.includes(srcNode?.attributes?.type) ? nodeKeysLabel[srcNode?.attributes?.type] : srcNodeLabel}
                    />

                </Grid>

                <Grid item xs={6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        type={"text"}
                        name={"dest"}
                        fullWidth
                        required
                        label={"Destination"}
                        variant="outlined"
                        disabled={true}
                        inputRef={register()}
                        // defaultValue={getClusterletName(element?.endClusterlet?.id)}
                        defaultValue={''}
                        helperText={dstNode?.attributes?.type !== undefined && aiNodes.includes(dstNode?.attributes?.type) ? nodeKeysLabel[dstNode?.attributes?.type] : dstNodeLabel}
                    />

                </Grid>


                {/* Target Instance */}
                {srcNodeType !== 'external_function' && dstNodeType
                    !== 'external_function' && <Grid item xs={6}>
                        <TextField
                            name="instance"
                            InputLabelProps={{ shrink: true }}
                            type={"text"}
                            fullWidth
                            required={false}
                            label={"Target Instance"}
                            variant="outlined"
                            inputRef={register({ ...patternOnly })}
                            error={errors?.instance ? true : false}
                            helperText={errors?.instance ? messages[errors?.instance?.type] : ''}
                        />
                    </Grid>}

                <Grid item xs={6}>
                    <Controller
                        name="validate"
                        control={control}
                        render={({ field, value, onChange }) =>
                            <TextField
                                name="validate"
                                {...field}
                                label={"Validation"}
                                fullWidth
                                value={value}
                                select
                                variant="outlined"
                                onChange={e => { onChange(e)}}
                            >
                                <MenuItem value="none">None</MenuItem>
                                <MenuItem value="send">Before Send</MenuItem>
                                <MenuItem value="recv">Before Recieve</MenuItem>
                                <MenuItem value="both">Both</MenuItem>
                            </TextField>
                        }
                    />
                </Grid>

                {/* <Grid item xs={6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        type={"text"}
                        name={"timeout"}
                        fullWidth
                        label={"Timeout"}
                        variant="outlined"
                        inputRef={register()}
                        placeholder="In milliseconds"
                        defaultValue={''}
                    />

                </Grid> */}

                <Grid item xs={6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        type={"text"}
                        name={"key"}
                        fullWidth
                        label={"Load Balance Key"}
                        variant="outlined"
                        inputRef={register()}
                        defaultValue={''}
                    />

                </Grid>

                <Grid item xs={6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        type={"text"}
                        name={"context"}
                        fullWidth
                        label={"Load Balance Context"}
                        variant="outlined"
                        disabled={!watch('key') || watch('key') === "" ? true : false}
                        inputRef={register()}
                        defaultValue={''}
                    />

                </Grid>
                

                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                    <CreateCancel onCreate={handleSubmit(onEventSave)} onCancel={onCancel} createDisable={(action.action === 'create_message' || isCreating) ? true : false} content={isCreating ? 'Creating..' : 'Create'} />
                </Grid>


            </Grid>
                    
            {!showEventForm && <CreateMessage saveTrigger={saveTrigger} hideMessageForm={hideMessageForm} />}

            {filterSchemaMessages(allMessages,messageLists, mesageFromDb ) && <DatabaseSchemaValidationAlert/>}


        </>
    )
}